import { useCurrentClientManager } from '@cko/dashboard-shared';
import { useQuery, QueryKey } from '@tanstack/react-query';
import { useGetUserProfileFetcher } from './useGetUserProfileFetcher';
import { UserProfile } from './types';

export const useGetUserProfile = () => {
  const { client } = useCurrentClientManager();
  const fetcher = useGetUserProfileFetcher();
  const queryKey: QueryKey = [
    '/gateway/profile',
    {
      clientId: client.id,
    },
  ];

  return useQuery<UserProfile, Error>(queryKey, fetcher);
};
